import React from 'react';
import { CloseModalIcon, ModalContainer } from './components-styles';
import { CLOSE_POPUP_ICON } from '@Images';

const PaymentReviewModal: React.FC<any> = ({
  children,
  heading,
  onClose,
  isCenter,
  showCloseIcon = true
}) => {
  return (
    <ModalContainer isCenter={isCenter} padding={[32, 16]}>
      <div className="modal-body-container">
        {showCloseIcon && (
          <CloseModalIcon onClick={() => onClose(false)} src={CLOSE_POPUP_ICON} alt="close" />
        )}
        <span className="__heading">{heading}</span>
        {children}
      </div>
    </ModalContainer>
  );
};

export default PaymentReviewModal;
